import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import configSlice from "./slice/configSlice";
import applicationSlice from "./slice/applicationSlice";

export const store = configureStore({
    reducer:{
        configSlice,
        userSlice,
        applicationSlice
    }
});
